import {Quill} from "vue2-editor";

const Parchment = Quill.import('parchment');
/**
 * Applies indent as style instead of classes
 */
class IndentAttributor extends Parchment.Attributor.Style {
  add (node, value) {
    if (value === 0) {
      this.remove(node)
      return true
    } else {
      return super.add(node, `${value}em`)
    }
  }
}

const IndentStyle = new IndentAttributor('indent', 'text-indent', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['1em', '2em', '3em', '4em', '5em', '6em', '7em', '8em', '9em']
})

export {
  IndentStyle
}


// WEBPACK FOOTER //
// ./src/helpers/quill-extensions/index.js